var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "el-card",
        {
          staticClass: "management-notice-card mb14",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c("el-alert", {
            staticClass: "management-notice",
            attrs: { title: _vm.title, type: "info", "show-icon": "" },
            on: { close: _vm.handleClose },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }